import AdminDataTable from "../../core/DataTable/DataTable";

export function ResumeHistory() {
    return <AdminDataTable
        collection="resume"
        columns={[
            {
                name: "ID",
                field: "id",
                type: "text",
                edit: false
            },
            {
                name: "File",
                field: "fileUrl",
                type: "file",
                show: false,
            },
            {
                name: "Markdown",
                field: "markdown",
                type: "markdown",
                show: false,
                edit: true,
            },
            {
                name: "Created at",
                field: "createdAt",
                type: "datetime",
                edit: false,
            },
            {
                name: "Updated at",
                field: "updatedAt",
                type: "datetime",
                edit: false,
            },
        ]}
    />
}